import { type ComponentProps, forwardRef } from "react";
import { cn } from "../../../..";

export const RoundedButton = forwardRef<HTMLButtonElement, ComponentProps<"button">>(
	function Button(props, ref) {
		const { className, children, ...rest } = props;

		return (
			<button
				ref={ref}
				className={cn(
					"inline-flex snap-start items-center gap-2 whitespace-nowrap rounded-full bg-shades-light px-4 py-2 font-bold focus:outline-none focus:ring-1 focus:ring-black focus:ring-inset disabled:opacity-50",
					className,
				)}
				{...rest}
			>
				{children}
			</button>
		);
	},
);
